<template>
  <div>
    <nav class="navbar navbar-expand-lg custom-bg navbar-light static-top navbar-shadow">
      <div class="container">
        <a class="navbar-brand" :href="mimedUrl">
          <img src="/img/logomimed.svg" class="logoCustom" alt="" />
        </a>
        <button
          @click="showLoginButton()"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse justify-content-end"
          id="navbarResponsive"
          v-if="isLoggedIn"
        >
          <a href="/api/logout">
            <div class="row pointer-click">
              <div class="col-4">
                <img src="/img/group-3.svg" class="d-block mx-auto userIcon" alt="" />
              </div>
              <div class="col-8">
                <span class="login-text">Cerrar sesión</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </nav>
    <!-- Desktop Version -->
    <div class="d-none d-md-block custom-heigth-min custom-bg">
      <section class="container-custom theme-blue-bg pt-md-4 pb-md-5 py-3">
        <div class="container">
          <div class="row">
            <div class="col-12 pt-md-1 py-3">
              <div class="main-heading">
                <div class="row mb-58 ml-2">
                  <div class="col-md-7 mt-2">
                    <div class="row mt-md-8">
                      <div class="col-md-12 desktop-text-blue-strong">Ten tus</div>
                      <div class="col-md-1 mt-3">
                        <div class="rectangle"></div>
                      </div>
                      <div class="col-md-11 desktop-text-item">Bonos</div>
                      <div class="col-md-1 mt-3">
                        <div class="rectangle"></div>
                      </div>
                      <div class="col-md-11 desktop-text-item">Licencias médicas</div>
                      <div class="col-md-1 mt-3">
                        <div class="rectangle"></div>
                      </div>
                      <div class="col-md-11 desktop-text-item">Horas médicas</div>
                    </div>
                    <div class="desktop-text-blue-strong">Siempre a mano con</div>
                  </div>
                  <div class="col-md-4 ml-5 mt-md-9">
                    <div class="mt-md-3">
                      <button
                        class="btn btn-primary btn-custom-radius"
                        @click="goToMimedRegister()"
                      >
                        <span class="custom-btn-text">Crea tu cuenta ahora</span>
                      </button>
                    </div>
                    <div class="desktop-text-item-r ml-md-2 mt-md-4 text-center">
                      <span>y consulta tu información</span>
                      <span>cuando quieras.</span>
                    </div>
                    <div class="desktop-text-blue-r text-center">¡Es gratis!</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section-top pb-2">
        <div class="py-2 pl-2 round-card bg-white card-shadow mobile-card">
          <div class="tab-content px-4 mt-md-5" id="pills-tabContent">
            <span class="desktop-text-bono">Tus Bonos comprados</span>
          </div>
          <div class="pb-md-3">
            <span class="desktop-text-subPage">
              Este documento pdf contiene
              <span class="blue-color"><strong>todos los bonos de tu atención.</strong></span> No
              olvides revisar hasta la última página.
            </span>
          </div>
          <div
            class="row hideMobile"
            v-for="(bonoPdf, index) in arrPdfDailyBonos"
            v-bind:key="bonoPdf.FolioBonos"
          >
            <div class="col-12 text-center">
              <iframe
                v-if="index + 1 === currentPdf"
                :src="mobileHref(bonoPdf.payload)"
                style="width: 95%; height: 600px"
                frameborder="0"
                title="Bono"
              ></iframe>
            </div>
          </div>
          <div class="tab-content px-4 d-flex justify-content-end mt-2" id="pills-tabContent">
            <nav aria-label="Page navigation example">
              <ul class="pagination pagination-sm">
                <span class="desktop-text-pagination mobile-text-pagination pr-2 mt-1"
                  >Mostrando {{ currentPdf }} de {{ arrPdfDailyBonos.length }}
                </span>
                <li class="page-item">
                  <a
                    class="page-link"
                    aria-label="Previous"
                    @click="previousPage()"
                    :disabled="currentPdf === 1"
                  >
                    <span aria-hidden="true" class="custom-size-pagination">&laquo;</span>
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link custom-size-pagination">{{ currentPdf }}</a>
                </li>
                <li class="page-item">
                  <a class="page-link" @click="nextPage()" aria-label="Next">
                    <span aria-hidden="true" class="custom-size-pagination">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </div>
    <section>
      <private-footer />
    </section>
    <div v-if="modalShow">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="row d-block text-center mt-3">
                    <div class="col-12" role="status">
                      <span class="desktop-text-modal"
                        >Ingresa el rut del beneficiario para ver el documento</span
                      >
                    </div>
                  </div>
                  <div class="row mt-3 p-1">
                    <div class="col-12 form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="rut"
                        @change="formatRut()"
                        placeholder="Ingresa rut sin puntos ni guión"
                      />
                      <small class="form-text text-muted msjCustom">{{ this.msjError }}</small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 p-3 mb-1 text-center">
                      <button
                        type="button"
                        class="btn btn-custom-modal"
                        @click="validateRut()"
                        :disabled="showSpinner"
                      >
                        <span
                          v-if="showSpinner"
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span class="sr-only">Loading...</span> Consultar bono
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <suBono-register
      v-if="modalRegister"
      @closeModal="closeModal"
      v-bind:userData="this.arrPdfDailyBonos[0]"
      v-bind:notification="this.notification"
    />
    <!-- Mobile Version -->
    <div class="d-block d-md-none custom-bg pt-2">
      <a v-if="showLogin" href="/mimed/bonoHistory">
        <div class="row pointer-click p-2 login-button-mobile mx-auto justify-content-center">
          <div class="col-2">
            <img src="/img/newprofile.svg" class="d-block mx-auto userIcon" alt="" />
          </div>
          <div class="col-6 d-flex align-items-center">
            <span class="login-text-mobile">Iniciar sesión</span>
          </div>
        </div>
      </a>
      <div class="text-center pt-3">
        <div class="row" style="margin: auto">
          <div class="col-md-12 mobile-text-blue-strong">Ten tus Bonos, Licencias</div>
          <div class="col-md-12 mobile-text-blue-strong">y Horas médicas</div>
        </div>
      </div>
      <section class="mobile-hand">
        <div class="row" style="margin-right: auto; margin-left: auto">
          <div class="col-4"></div>
          <div class="col-8 pl-5 pr-0">
            <div class="mobile-secondary-text-blue pr-0 pt-4 mb-2">Siempre a mano con</div>
            <div class="row mr-0">
              <div class="col-7 mb-1 pr-0">
                <img src="/img/mimed-logo-mobile.svg" alt="mimed_logo" />
                <div class="mobile-text-blue-r py-3">¡Es gratis!</div>
              </div>
              <div class="col-4 icons">
                <img src="/img/bono_icons_mobile.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="row text-center" style="margin-right: auto; margin-left: auto">
          <div class="col mobile-button-position">
            <button
              class="btn btn-primary btn-custom-radius"
              @click="goToMimedRegister()"
              id="crea-cuenta-mobile"
            >
              <span class="custom-btn-text">Crea tu cuenta ahora</span>
            </button>
          </div>
        </div>
      </section>

      <section class="bg-wave">
        <div class="bg-white card-shadow mobile-card mt-4">
          <div id="pills-tabContent">
            <span class="mobile-text-bono">Tus Bonos comprados</span>
          </div>
          <div>
            <span class="mobile-text-subPage">
              Este documento pdf contiene
              <span class="blue-color"><strong>todos los bonos de tu atención.</strong></span> No
              olvides revisar hasta la última página.
            </span>
          </div>
          <div
            class="row showMobile hideDesktop text-center"
            v-for="(bonoPdf, index) in arrPdfDailyBonos"
            v-bind:key="index"
          >
            <div class="col-12">
              <a
                class="btn btn-mobile-pdf mt-4"
                :download="'Archivo pdf ' + index"
                :href="mobileHref(bonoPdf.payload)"
                id="descargar-bono-mobile"
              >
                <span class="sr-only p-2">Loading...</span> Descargar PDF {{ index + 1 }}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { BButton, BModal, VBModal } from 'bootstrap-vue';
import { iosDevice, getUrlBase64 } from '../../mixins/functions';
const { validate, clean, format } = require('rut.js');

export default {
  name: 'subono',
  components: {
    BButton,
    BModal,
    VBModal,
  },
  props: ['notification'],
  data: () => ({
    isLoggedIn: false,
    modalShow: true,
    showSpinner: false,
    modalRegister: false,
    rut: '',
    msjError: '',
    arrPdfDailyBonos: '',
    currentPdf: 1,
    showLogin: false,
    mimedUrl: process.env.MIX_MIMED_FRONT_URL,
    mimed: process.env.MIX_MIMED_URL,
    enviroment: enviromentTags,
    urlBff: process.env.MIX_MIMED_BFF_URL,
  }),
  async mounted() {
    this.mountGoogleTagManager();
    if (this.notification.length > 0) {
      let user = await JSON.parse(localStorage.getItem('register'));
      this.rut = user.rut;
      await this.validateRut();
      this.modalShow = false;
      this.modalRegister = true;
    }
  },
  beforeMount() {
    let url = new URL(window.location.href);
    this.uuid = url.searchParams.get('uuid');
  },
  methods: {
    showLoginButton() {
      this.showLogin = !this.showLogin;
    },
    previousPage() {
      if (this.currentPdf <= this.arrPdfDailyBonos.length && this.currentPdf > 1) {
        this.currentPdf--;
      }
    },
    nextPage() {
      if (this.currentPdf < this.arrPdfDailyBonos.length) {
        this.currentPdf++;
      }
    },
    openModalRegister() {
      this.modalRegister = true;
    },
    goToMimedRegister() {
      window.location.href = `${this.mimed}/registro`;
    },
    formatRut() {
      this.rut = format(this.rut);
    },
    closeModal() {
      this.modalRegister = false;
    },
    mountGoogleTagManager() {
      let d = document;
      let s = d.createElement('script');
      let noscript = d.createElement('noscript');
      if (this.enviroment !== 'production') {
        s.src = '../../../js/google_tag_manager_header_qa.js';
      } else {
        s.src = '../../../js/google_tag_manager_header.js';
      }
      s.id = 'tag-manager';
      d.getElementsByTagName('head')[0].appendChild(s);
      noscript.innerText = this.tagManagerText();
      d.getElementsByTagName('body')[0].appendChild(noscript);
    },

    tagManagerText() {
      if (this.enviroment !== 'production') {
        return `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P5NSHML"
        "height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      }
      return `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PP8GQNR"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    },
    async validateRut() {
      if (validate(this.rut)) {
        this.showSpinner = true;
        this.msjError = '';
        this.rut = this.rut.split('.').join('');
        try {
          let dataGetBono = {
            uuid: this.uuid,
            nid: this.rut,
          };
          const dailyBonos = await axios.post(`${this.urlBff}api/v1/bonos/daily`, dataGetBono);
          const arrDailyBono = [];
          arrDailyBono.push(dailyBonos.data.data);
          if (dailyBonos.data.status === 1) {
            if (arrDailyBono.length == 0) {
              this.showSpinner = false;
              this.msjError = 'No se encontraron bonos asociados a este RUT';
              return;
            } else {
              this.arrPdfDailyBonos = dailyBonos.data.data;
            }
            this.showSpinner = false;
            this.modalShow = false;
            return;
          }
          if (dailyBonos.data.status === 204) {
            this.showSpinner = false;
            this.msjError = 'No se encontraron bonos asociados a este RUT';
            return;
          }
        } catch (error) {
          if (error.response.data.status === 0) {
            this.msjError = 'No se encontraron bonos asociados a este RUT';
            this.showSpinner = false;
          }
        }
        return;
      }
      this.msjError = 'El rut ingresado es inválido';
      this.showSpinner = false;
      return;
    },
    mobileHref(pdf) {
      return getUrlBase64(pdf, 'application/pdf');
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://use.fontawesome.com/releases/v5.13.0/css/all.css');
.navbar-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}
.custom-heigth-min {
  min-height: calc(100vh - -70px - 170px);
}
.custom-bg {
  background-color: #ffffff;
}
.bg-white {
  background-color: #edf8ff;
  height: 100%;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  display: table;
  transition: opacity 0.3s ease;
}
.container-custom {
  width: 100%;
}
.custom-btn-text {
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}
.theme-blue-bg {
  background-image: url('/img/bg_hand.svg');
  background-repeat: no-repeat;
  background-position: center;
  height: 470px !important;
  margin-top: -50px;
}
.mobile-hand {
  background-image: url('/img/bono_wave.svg'), url('/img/hand_phone_mobile.svg');
  background-repeat: no-repeat, no-repeat;
  background-position: 50% 110%, left;
  height: 230px;
  margin-left: -55px;
}
.bg-wave {
  background: #edf8ff;
  border: 1px solid #edf8ff;
}
.main-heading h2 {
  font-size: 35px;
  font-weight: normal;
  color: #ffffff;
  margin-bottom: 15px;
  line-height: 1.14;
}
.main-heading p {
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #ffffff;
}
.desktop-text-size {
  font-size: 23px;
}
.mb-58 {
  margin-bottom: 58px !important;
}
.desktop-text-blue-strong {
  color: #092e6d;
  font-family: 'Poppins', sans-serif;
  font-size: 27px;
  font-weight: 600;
  letter-spacing: 0.19px;
  line-height: 38px;
}
.login-button-mobile {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  width: 340px;
  height: 54px;
}
.mobile-text-blue-strong {
  color: #092e6d;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.17px;
  line-height: 24px;
}
.mobile-secondary-text-blue {
  color: #092e6d;
  font-family: 'Poppins', sans-serif;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 38px;
}
.icons {
  margin-top: -25px;
  margin-left: 5px;
}
.rectangle {
  height: 7px;
  width: 7px;
  border-radius: 0 74px 74px 0;
  background-color: #369ae8;
}
.desktop-text-blue {
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: left;
  color: #3fb2ff;
}
.desktop-text-blue-r {
  color: #369ae8;
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 42px;
  text-align: center;
}
.mobile-text-blue-r {
  color: #369ae8;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 35px;
}
.desktop-text-white-pie {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.desktop-text-subPage {
  color: #3f3f3f;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  letter-spacing: 0.19px;
  line-height: 26px;
  padding-left: 3%;
}
.mobile-text-subPage {
  color: #3f3f3f;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 21px;
}
.login-text-mobile {
  color: #092f6d;
}
.round-card {
  border-radius: 14px !important;
  width: 930px;
  margin: 25px auto;
}
.section-top {
  position: relative;
  top: -100px;
}
.card-shadow {
  box-shadow: 0 2px 6px rgba(57, 100, 128, 0.67);
}
.desktop-text-bono {
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.1px;
  text-align: left;
  color: #092f6d;
}
.mobile-text-bono {
  font-family: 'Poppins', sans-serif;
  font-size: 27px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: #092f6d;
}
.desktop-text-pagination {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.14px;
  text-align: center;
  color: #212529;
}
.desktop-text-modal {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.1px;
  text-align: center;
  color: #1b1b1b;
}
.btn-custom-modal {
  width: 100%;
  border-radius: 4px;
  background-color: #e8faf5;
  color: #33cca0;
  font-weight: 500;
}
.btn-custom-modal:hover {
  background-color: #33cca0;
  color: #ffffff;
}
.btn-custom-pdf {
  width: 90%;
  border-radius: 4px;
  background-color: #0091ff;
  color: #ffffff;
  font-weight: 500;
}
.btn-mobile-pdf {
  width: 290px;
  height: 52px;
  border-radius: 8px;
  background-color: #8bc6f0;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.1px;
}
.desktop-text-item {
  color: #07357b;
  font-family: 'Poppins', sans-serif;
  font-size: 19px;
  letter-spacing: 0.14px;
  line-height: 38px;
  margin-left: -5%;
}
.desktop-text-item-r {
  color: #07357b;
  font-family: 'Poppins', sans-serif;
  font-size: 19px;
  letter-spacing: 0.14px;
  margin-left: -5%;
}
.hideDesktop {
  display: none;
}
.text-muted {
  color: red !important;
}
.btn-custom-radius {
  border-radius: 12px;
  background-color: #22c184;
  box-shadow: 0 6px 9px 3px rgba(34, 193, 132, 0.33);
  width: 296px;
  height: 54px;
}
.mobile-button-position {
  margin-left: 55px;
}
.container {
  width: 960px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(23, 22, 22, 0.8);
  display: table;
  transition: opacity 0.3s ease;
}
@media (max-width: 768px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 720px;
  }
  .btn-buscar {
    padding: 11px 9px;
  }
  .slider .carousel-item {
    height: 230px;
  }
  .main-heading p {
    font-size: 21px;
  }
}
@media (max-width: 767px) {
  .custom-size-pagination {
    font-size: 13px !important;
  }
  .mobile-text-pagination {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.14px;
    text-align: center;
    color: #212529;
  }
  .showMobile {
    display: block;
  }
  .hideMobile {
    display: none;
  }
  .mobile-text-white-pie {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    display: block;
  }
  .custom-heigth-min {
    min-height: calc(162vh - -70px - 170px) !important;
  }
  .round-card {
    border-radius: 14px !important;
    width: 100% !important;
    margin: 0 auto;
  }
  .mobile-card {
    padding: 20px 16px 23px 16px !important;
    margin: 25px 10px 36px 10px !important;
    border-radius: 8px;
  }
  .main-heading h2 {
    font-size: 28px;
    color: #33cca0 !important;
    font-weight: bold;
  }
  .main-heading p {
    font-size: 16px;
  }
  .section-top {
    position: relative;
    top: -70px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .form-tab .nav-item {
    width: 50%;
  }
  .mishoras p {
    font-size: 20px;
  }
  .select-ico > .form-control {
    font-size: 13px;
  }
  .revisa-brd {
    border-bottom: 0;
  }
  .mishoras {
    height: auto;
    padding: 0;
  }
  .detos-info-info span {
    width: 40px;
    height: 45px;
  }
  .detos-info-info span svg {
    font-size: 20px;
  }
  .btn-time {
    border-radius: 4px;
    background-color: #0091ff;
    color: #ffffff;
    font-size: 16px;
    padding: 15px;
    width: 100%;
    margin-top: 22px;
    font-weight: 500;
  }
  .slider .carousel-item {
    height: 455px;
  }
  .btn-video {
    color: #3fb2ff;
    font-size: 20px;
    margin-top: 15px;
  }
  .slider-text {
    margin-top: 35px !important;
    text-align: center;
  }
  .slider-text h2 {
    font-size: 20px;
  }
  .carousel-indicators {
    right: unset;
    left: 50%;
    transform: translateX(-50%);
  }
  .slider-text p {
    margin-top: 20px;
  }
  .mob-footer {
    border-radius: 28px 28px 0 0;
    box-shadow: 0 -1px 4px 0 rgba(112, 107, 107, 0.5);
    background-color: #ffffff;
    padding: 16px 20px;
  }
  .btn-hour {
    border-radius: 4px;
    background-color: #e9ecf2;
    padding: 12px 17px;
    color: #092f6d;
    font-weight: 600;
  }
  .btn-hour:hover {
    background-color: #092f6d;
    color: #e9ecf2;
  }
  .slider-control {
    display: none;
  }
  .bars {
    position: absolute;
    top: 20px;
    right: 15px;
    display: block;
  }
  .text-bold-blue {
    font-weight: bold;
    color: #3fb2ff;
    padding-left: 0 !important;
    font-size: 33px !important;
  }

  .mobile-text-size {
    font-size: 33px !important;
  }

  .mobile-img-size {
    width: 300px !important;
    height: auto !important;
    margin: 0 0 0 -10px !important;
  }
  .text-align-mobile {
    text-align: center !important;
  }
}
.left-alignment {
  margin-left: -140px;
}

.modal-backdrop {
  height: 104vh !important;
}
.blue-color {
  color: #0a2e6d;
}
</style>
